import {
    Component,
    EventEmitter,
    inject,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { LogicStepParameter, WdxDestroyClass } from '@wdx/shared/utils';
import {
    ParamsChangedEvent,
    WorkflowContext,
    WorkflowNodeType,
} from '../../models';
import { WorkflowParameterFormService } from '../../services';
import { IWrappedWorkflowFormComponentProvider } from '../../interfaces';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'clmi-workflow-designer-parameters',
    templateUrl: './workflow-designer-parameters.component.html',
    styleUrls: ['./workflow-designer-parameters.component.scss'],
    standalone: false,
})
export class WorkflowDesignerParametersComponent
    extends WdxDestroyClass
    implements OnChanges
{
    private readonly fb = inject(FormBuilder);
    private readonly parameterFormService = inject(
        WorkflowParameterFormService,
    );

    @Input() context: WorkflowContext;
    @Input() componentProvider?: IWrappedWorkflowFormComponentProvider;

    @Output() paramsChanged = new EventEmitter<ParamsChangedEvent>();

    public formGroup: FormGroup = this.fb.group({});
    public WorkflowNodeType = WorkflowNodeType;

    ngOnChanges(changes: SimpleChanges): void {
        this.formGroup = this.fb.group({});
        if (changes['context']) {
            if (this.context?.parameters) {
                this.formGroup = this.parameterFormService.buildFormGroup(
                    this.context.parameters,
                    this.context.paramValues,
                );
                this.formGroup.markAllAsTouched();
            }

            this.formGroup.valueChanges
                .pipe(takeUntil(this.destroyed$))
                .subscribe((values) => {
                    const transformed =
                        this.parameterFormService.transformSavedValues(
                            values,
                            this.context.parameters,
                        );

                    this.paramsChanged.emit({
                        formValues: transformed,
                        isValid:
                            this.formGroup.valid && !this.formGroup.pending,
                    });
                });
        }
    }

    addCollectionItem(param: LogicStepParameter): void {
        const array = this.formGroup.get(param.code) as FormArray;
        this.parameterFormService.addCollectionItem(array, param);
    }

    removeCollectionItem(paramCode: string, index: number): void {
        const array = this.formGroup.get(paramCode) as FormArray;
        this.parameterFormService.removeCollectionItem(array, index);
    }
}
